export default {
    state: {
        loading: false
    },
    getters: {

    },
    mutations: {
        setLoading(state, val){
            state.loading = val
        }
    },
    actions: {
    }
}